#import "../fragments/drip-progression-fragment.graphql"

mutation CancelDripProgression($input: DripProgressionDeleteInput!) {
    dripProgressionDelete(input: $input) {
        dripProgression {
            ...DripProgressionFragment
        }
    }
}
